import { createAction, props } from "@ngrx/store";

export const addFavorite = createAction(
    '[MAP] Update favorites',
    props<{ favorite: any }>()
);

